import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import Label14 from '../../../theme/labels/Label14';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        stepsBar: {
            textAlign: 'center',
            marginTop: theme.spacing(7),
            marginBottom: theme.spacing(7),
            '& .label': {
                marginBottom: theme.spacing(2),
            },
            '& .bar, & .empty-bars': {
                display: 'inline-block',
                marginRight: 8,
                width: 40,
                height: 4,
                borderRadius: '7.5px',
            },
            '& .bar': {
                backgroundColor: theme.palette.primary.main,
            },
            '& .empty-bars': {
                backgroundColor: '#F4F2FF',
            },
        },
    }),
);

export interface StepsBarProps {
    // if you are changing this, make sure to change the loop in the component below
    stepInfo: 1 | 2;
}

const stepText = (stepInfo: StepsBarProps['stepInfo']): string => {
    switch (stepInfo) {
        case 1:
            return 'Organization Info';
        case 2:
            return 'Personal Info';

        default:
            return 'Signup Info';
    }
};

const StepsBar: React.FC<StepsBarProps> = ({ stepInfo }) => {
    const { stepsBar } = useStyles();
    const bars: JSX.Element[] = [];
    const emptyBars: JSX.Element[] = [];
    for (let i = 0; i < stepInfo; i++) {
        bars.push(<div key={`bar-${i}`} className="bar" />);
    }
    for (let i = 0; i < 2 - stepInfo; i++) {
        emptyBars.push(<div key={`empty-bar-${i}`} className="empty-bars" />);
    }
    return (
        <div className={`${stepsBar} fs-unmask`}>
            <Label14 className="label">{stepText(stepInfo)}</Label14>
            {bars}
            {emptyBars}
        </div>
    );
};

export default StepsBar;
